<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="excmdailyplanitem_state"
        class="form-control-label">state</label>
      <input
        id="excmdailyplanitem_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="excmdailyplanitem_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="excmdailyplanitem_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="excmdailyplanitem_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="excmdailyplanitem_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="excmdailyplanitem_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="excmdailyplanitem_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_dailyPlan"
        class="form-control-label">dailyPlan</label>
      <input
        id="excmdailyplanitem_dailyPlan"
        v-model="item.dailyPlan"
        :class="['form-control', isInvalid('dailyPlan') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('dailyPlan', $event.target.value)">
      <div
        v-if="isInvalid('dailyPlan')"
        class="invalid-feedback">{{ violations.dailyPlan }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_timeStart"
        class="form-control-label">timeStart</label>
      <input
        id="excmdailyplanitem_timeStart"
        v-model="item.timeStart"
        :class="['form-control', isInvalid('timeStart') ? 'is-invalid' : '']"
        type="dateTime"
        required="true"
        placeholder=""
        @input="handleUpdateField('timeStart', $event.target.value)">
      <div
        v-if="isInvalid('timeStart')"
        class="invalid-feedback">{{ violations.timeStart }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_timeStop"
        class="form-control-label">timeStop</label>
      <input
        id="excmdailyplanitem_timeStop"
        v-model="item.timeStop"
        :class="['form-control', isInvalid('timeStop') ? 'is-invalid' : '']"
        type="dateTime"
        required="true"
        placeholder=""
        @input="handleUpdateField('timeStop', $event.target.value)">
      <div
        v-if="isInvalid('timeStop')"
        class="invalid-feedback">{{ violations.timeStop }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_task"
        class="form-control-label">task</label>
      <input
        id="excmdailyplanitem_task"
        v-model="item.task"
        :class="['form-control', isInvalid('task') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('task', $event.target.value)">
      <div
        v-if="isInvalid('task')"
        class="invalid-feedback">{{ violations.task }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_order"
        class="form-control-label">order</label>
      <input
        id="excmdailyplanitem_order"
        v-model="item.order"
        :class="['form-control', isInvalid('order') ? 'is-invalid' : '']"
        type="number"
        required="true"
        placeholder=""
        @input="handleUpdateField('order', $event.target.value)">
      <div
        v-if="isInvalid('order')"
        class="invalid-feedback">{{ violations.order }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_type"
        class="form-control-label">type</label>
      <input
        id="excmdailyplanitem_type"
        v-model="item.type"
        :class="['form-control', isInvalid('type') ? 'is-invalid' : '']"
        type="number"
        required="true"
        placeholder=""
        @input="handleUpdateField('type', $event.target.value)">
      <div
        v-if="isInvalid('type')"
        class="invalid-feedback">{{ violations.type }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplanitem_distance"
        class="form-control-label">distance</label>
      <input
        id="excmdailyplanitem_distance"
        v-model="item.distance"
        :class="['form-control', isInvalid('distance') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('distance', $event.target.value)">
      <div
        v-if="isInvalid('distance')"
        class="invalid-feedback">{{ violations.distance }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
